import http from "../http-common";

// NOTE: These endpoints can only be called in the ProGroup instancce of Cumulus - that server is going to be the source of truth for this data
class NewsAndPatchNotesDataService {
    // create a new news item
    createNewsItem(data) {
        return http.post(`/newsAndPatchNotes/createNewsItem`, data);
    }

    // edit a news item
    editNewsItem(data) {
        return http.post(`/newsAndPatchNotes/editNewsItem`, data);
    }

    // delete a news item
    deleteNewsItem(id) {
        return http.delete(`/newsAndPatchNotes/deleteNewsItem?id=${id}`);
    }
}

export default new NewsAndPatchNotesDataService();